import { useContext } from 'react'
import FieldInput from './Field/FieldInput'
import { BookingContext } from '../context';
import styles from './index.module.scss'
import { useEffect } from 'react';


export default function TicketRow({ index, fields }) {

    const { customer } = useContext(BookingContext)

    // manual custom sort order no matter the order in WC "Ticket Fields" tab (to keep the field layout how we want it)
    let sort = ['First Name', 'Last Name', 'Job Title',  'Email']
    let fieldEntries = fields ? Object.entries(fields) : []
    fieldEntries.sort((a, b) => sort.indexOf(a[1].label) > sort.indexOf(b[1].label) ? 1 : -1)

    return (
        <div className={styles.row}>
            <div className={styles.index}>Ticket #{index+1} {index === 0 && <>(Primary)</>}</div>
            <div className={styles.fields}>

                {fieldEntries && fieldEntries.map(([key, field]) => {

                    let defaultValue = false
                    if ( index === 0 && customer ) {
                        defaultValue = customer[field.type] || customer[field.label]
                    }

                    switch(field.type) {
                        case 'text':
                        case 'first_name':
                        case 'last_name':
                        case 'email':
                            return <FieldInput name={`ticket_fields[${index}][${key}]`} index={index} defaultValue={defaultValue} fieldKey={key} field={field} />
                    }

                })}
            </div>
        </div>
    )

}